import { render } from "./friendList.vue?vue&type=template&id=31d38ffb"
import script from "./friendList.vue?vue&type=script&lang=js"
export * from "./friendList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__